import * as React from 'react';
import { Fragment } from 'react';
import {
  AutocompleteInput,
  BooleanField,
  DatagridConfigurable,
  DateField,
  DateInput,
  ExportButton,
  FilterButton,
  List,
  NullableBooleanInput,
  ReferenceInput,
  SearchInput,
  SelectColumnsButton,
  TextField,
  TextInput,
  TopToolbar,
  useRecordContext,
  EmailField,
  ShowButton,
  EditButton,
  ReferenceField,
  DeleteButton,
  ListBase,
  Title,
  ListToolbar,
  Pagination,
  Datagrid
} from 'react-admin';
import { useMediaQuery, Divider, Theme, Card, Box, Grid } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import ComponentList from '../../components/PageComponents/ComponentList';
import MobileGrid from './MobileGrid';
import { Account } from '../../models/account';


const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <FilterButton />
    <ExportButton />
  </TopToolbar>

);

const UserList = () => (

  <>
    <Helmet>
      <title>Coinhouse Solutions - Accounts list</title>
    </Helmet>
    <ComponentList title="Account Management" subtitle="All accounts can be managed from this page" filters={orderFilters} actions={<ListActions />}>
      <TabbedDatagrid />
    </ComponentList>
  </>
);

const orderFilters = [
  <SearchInput source="q" alwaysOn />,
  <ReferenceInput source="name" reference="account">
    <AutocompleteInput
      optionText={(choice?: Account) =>
        choice?.id // the empty choice is { id: '' }
          ? `${choice.firstname} ${choice.lastname}`
          : ''
      }
    />
  </ReferenceInput>,
  <DateInput source="dateCreated" />,
  <TextInput source="Id" />,
  <NullableBooleanInput source="active" />,
];

const TabbedDatagrid = () => {
  const isXSmall = useMediaQuery<Theme>(theme =>
    theme.breakpoints.down('sm')
  );

  return (
    <Fragment>
      <Divider />
      {isXSmall ? (
        <MobileGrid />
      ) : (
        <>
          <DatagridConfigurable
            rowClick="show"
            omit={[]}
            sx={{
              '& .RaDatagrid-headerCell': {
                padding: '16px',
                background: 'none',
              },
              '& .RaDatagrid-headerRow': {
                transition: 'background-color 0.2s ease 0s !important',
                backgroundColor: 'rgba(34, 51, 84, 0.02)  !important'
              }
            }}
          >
            <TextField source="id" />
            <TextField source="name" />
            <DateField source="created" />
            <ShowButton />
            <EditButton />
            <DeleteButton />
          </DatagridConfigurable>
        </>
      )}
    </Fragment>
  );
};

export default UserList;